import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {ConstantPropertyDataService} from "../../../data/constant-property-data.service";
import {ComponentNameFormulaBuilderService} from "../../../services/component-name-formula-builder.service";
import {IDMap, KeyMap} from "../../../_typing/generic-types";
import {ConstantProperty} from "../../../_models/constant-property";
import {isEmpty as _isEmpty} from "lodash-es";
import {FormulaPart, NameFormula} from "../../../_typing/config/component-name-formula-config";
import {CommonModule} from "@angular/common";
import {MatTooltip} from "@angular/material/tooltip";
import {MatSnackBarRef} from "@angular/material/snack-bar";
import {ConfirmSnackbarComponent} from "../../../notifications/snackbar/confirm-snackbar/confirm-snackbar.component";
import {take} from "rxjs/operators";
import {NotificationService} from "../../../services/notification.service";

@Component({
    selector: 'component-name-formula-table',
    templateUrl: './component-name-formula-table.component.html',
    styleUrls: ['./component-name-formula-table.component.less', '../../../shared/styles/shared-table-styles.less'],
    imports: [
        CommonModule,
        MatTooltip
    ],
})
export class ComponentNameFormulaTableComponent implements OnInit {
    @Input() nameFormulas: KeyMap<NameFormula>;
    @Input() cpDict: IDMap<ConstantProperty>;
    @Input() selectedKey = 0;

    @Output() nameFormulasChange = new EventEmitter<KeyMap<NameFormula>>();
    @Output() formulaSelected = new EventEmitter<string>();
    @Output() formulaDeleted = new EventEmitter<string>();
    public isEmpty = _isEmpty;

    constructor(private formulaBuilder: ComponentNameFormulaBuilderService,
                private notification:NotificationService) {
    }

    ngOnInit() {
        this.selectFormula(this.selectedKey);

    }

    nameString(formula: FormulaPart[]) {
        if (formula) {
            return this.formulaBuilder.getNameString(formula, this.cpDict)
        }
    }

    selectFormula(i) {
        this.selectedKey = i;
        this.formulaSelected.emit(i);
    }

    removeItem(key: string): void {
        let confirmNotification: MatSnackBarRef<ConfirmSnackbarComponent>;
        confirmNotification = this.notification.openConfirm("Are you sure you want to delete this formula?", "No", "Yes, I'm sure");
        confirmNotification.onAction().pipe(take(1)).subscribe((): void => {
            delete this.nameFormulas[key];
            this.nameFormulasChange.emit(this.nameFormulas);
            this.formulaDeleted.emit(key);
        });
    }
}
